import { render, staticRenderFns } from "./ExcluirConta.vue?vue&type=template&id=e9aef7e8&"
import script from "./ExcluirConta.vue?vue&type=script&lang=js&"
export * from "./ExcluirConta.vue?vue&type=script&lang=js&"
import style0 from "./ExcluirConta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports